import { render, staticRenderFns } from "./LanguageFlag.vue?vue&type=template&id=65ac8297&scoped=true"
import script from "./LanguageFlag.vue?vue&type=script&lang=js"
export * from "./LanguageFlag.vue?vue&type=script&lang=js"
import style0 from "./LanguageFlag.vue?vue&type=style&index=0&id=65ac8297&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ac8297",
  null
  
)

export default component.exports